import type { ReactNode } from 'react';

import { ARTICLE_TOKENS } from '../design-tokens';
import type { SanityStatCalloutBlock } from '@lib/article-blocks/types';

const ACCENT_BORDER = {
  blue: 'border-l-[#3fa9f5]',
  pink: 'border-l-[#ff2f6d]'
} as const;

const emphasise = (text: string, highlight: string | undefined): ReactNode => {
  if (!highlight) return text;
  const index = text.toLowerCase().indexOf(highlight.toLowerCase());
  if (index === -1) return text;
  return (
    <>
      {text.slice(0, index)}
      <strong className={`font-semibold ${ARTICLE_TOKENS.ink}`}>
        {text.slice(index, index + highlight.length)}
      </strong>
      {text.slice(index + highlight.length)}
    </>
  );
};

export const StatCalloutBlock = ({
  value
}: {
  value: SanityStatCalloutBlock;
}) => {
  const items = value.items ?? [];
  if (items.length === 0) return null;
  return (
    <div
      className="not-prose my-7 grid gap-4 sm:grid-cols-2"
      data-cy="stat-callouts"
    >
      {items.map((item, index) => (
        <div
          key={item._key ?? index}
          className={`rounded-[4px_12px_12px_4px] border border-l-[3px] px-5 py-[18px] ${
            ARTICLE_TOKENS.rule
          } ${ACCENT_BORDER[item.accent ?? 'blue']}`}
        >
          <div
            className={`font-heading text-[40px] font-extrabold leading-none ${ARTICLE_TOKENS.ink}`}
          >
            {item.value}
          </div>
          <p
            className={`mt-2 mb-0 font-body text-[14.5px] leading-[1.45] ${ARTICLE_TOKENS.bodyMuted}`}
          >
            {emphasise(item.text, item.highlight)}
          </p>
        </div>
      ))}
    </div>
  );
};
